// extracted by mini-css-extract-plugin
module.exports = {"banner":"healthcare-banner_banner__YhNfz","banner_text":"healthcare-banner_banner_text__0k9m8","banner_btn":"healthcare-banner_banner_btn__9mGuw"};